import React from 'react';
import { useCadastroProducao } from '../../hook/useCadastroProducao';
import { Col, Row } from 'react-bootstrap';
import { Container } from './style';
import { InputsForm } from './Inputs';

export const HeaderForm: React.FC = () => {
  const { formData } = useCadastroProducao();
  const { cod_loja, cod_produto, des_produto } = formData;

  const codLoja = cod_loja;
  const codProduto = cod_produto;
  const desProduto = des_produto;

  return (
    <Container>
      <Row>
        <Col sm={12} md={8}>
          <table className="table">
            <thead>
              <tr>
                <th>Loja</th>
                <th>PLU</th>
                <th>Produto</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{codLoja}</td>
                <td>{codProduto}</td>
                <td>{desProduto}</td>
              </tr>
            </tbody>
          </table>
        </Col>
        <Col sm={12} md={4}>
          <InputsForm />
        </Col>
      </Row>
    </Container>
  );
};
